import { useDispatch as useStoreDispatch } from "react-redux";

import store from "~/context";

const useDispatch = () => useStoreDispatch<typeof store.dispatch>();

export default useDispatch;
